import { isNativeApp } from './platform';

/** Open Stripe checkout and other external flows without leaving the native shell permanently. */
export async function openExternalUrl(url: string): Promise<void> {
  if (isNativeApp()) {
    const { Browser } = await import('@capacitor/browser');
    await Browser.open({ url });
    return;
  }
  window.location.assign(url);
}
